import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TenantSubscriptionsPage } from "@/features/tenant/SubscriptionsPage";

export const Route = createFileRoute("/app/tenant/subscriptions")({
  validateSearch: z.object({
    tab: z.enum(["subscriptions", "links"]).optional().catch(undefined),
    // ?create=1 (the dashboard's "Assign plan") opens the assign dialog.
    create: z.coerce.number().optional().catch(undefined),
  }),
  component: TenantSubscriptionsPage,
});
